import { render } from "./PhotoPage.vue?vue&type=template&id=2b4e4680&scoped=true"
import script from "./PhotoPage.vue?vue&type=script&lang=js"
export * from "./PhotoPage.vue?vue&type=script&lang=js"

import "./PhotoPage.vue?vue&type=style&index=0&id=2b4e4680&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b4e4680"]])

export default __exports__